export default function WarningIcon() {
  return (
    <svg
      width="21"
      height="18"
      viewBox="0 0 21 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.53968 7.2622C6.59799 4.05899 7.62715 2.45739 9.03937 2.04511C9.81628 1.8183 10.6532 1.8183 11.4301 2.04511C12.8423 2.45739 13.8715 4.05899 15.9298 7.2622C17.9881 10.4654 19.0172 12.067 18.7085 13.372C18.5387 14.0899 18.1202 14.7411 17.5131 15.2323C16.4097 16.125 14.3513 16.125 10.2347 16.125C6.11811 16.125 4.0598 16.125 2.95631 15.2323C2.34923 14.7411 1.93079 14.0899 1.76095 13.372C1.45222 12.067 2.48137 10.4654 4.53968 7.2622Z"
        stroke="#E5665B"
        stroke-width="2"
      />
      <path
        d="M10.4387 12.75V9.75C10.4387 9.39645 10.4387 9.21967 10.3138 9.10983C10.1889 9 9.98794 9 9.58594 9"
        stroke="#E5665B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2266 6.75H10.2342"
        stroke="#E5665B"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
